import { homePageStyles as styles } from "@insite/content-library/Pages/HomePage";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        padding: 0 15px 15px !important;
    `,
};
